import { Box, Typography, useTheme } from "@mui/material";
import * as React from "react";

interface IProps {
    id: string;
    label: string;
    selected: boolean;
    selectedBackgroundColor?: MprcColors;
    onClick?: () => void;
}

type Props = IProps;

export const PublicationChoice: React.FC<Props> = (props) => {
    const { id, label, selected, selectedBackgroundColor, onClick } = props;

    const theme = useTheme();

    return (
        <Box
            id={id}
            onClick={onClick}
            sx={
                {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    position: "relative",
                    margin: "5px",
                    height: "57px",
                    borderRadius: "16px",
                    backgroundColor: selected
                        ? selectedBackgroundColor
                            ? theme.palette[selectedBackgroundColor].main
                            : "highlight.main"
                        : theme.palette["chip"].main,
                    color: selected ? "white" : "default",
                    fontWeight: "normal",
                    "&&:hover": {
                        cursor: "pointer",
                        color: "white",
                        backgroundColor: selectedBackgroundColor
                            ? theme.palette[selectedBackgroundColor].main
                            : theme.palette["highlight"].dark
                    }
                }
            }
        >
            <Box
                sx={
                    {
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        paddingX: "15px",
                        width: "205px",
                        "&& p": {
                            display: "-webkit-box",
                            "-webkit-line-clamp": "2",
                            "-webkit-box-orient": "vertical",
                            "overflow": "hidden"
                        }
                    }
                }
            >
                <Typography
                    variant="h6"
                    component="p"
                    align="left"
                    color={selected ? "white" : "default"}>
                    {label}
                </Typography>
            </Box>
        </Box>
    );
};
